// extracted by mini-css-extract-plugin
export default {"loading":"Weather_loading__zA2Sl","container":"Weather_container__5++QW","data":"Weather_data__MGqm9"};